(function($) {
  'use strict';

  $('.js-tab-block .tab-menu li:first-child button')
    .addClass( 'is-active' );

  $('.js-tab-block .tab-items .single-tab')
    .css( 'display', 'none' );

  $('.js-tab-block .tab-items .single-tab:first-child')
    .css( 'display', 'block' )
    .addClass( 'is-active' );


  var $tab_button = $('.js-tab-button');

  $tab_button.on('click', function () {
    var $this       = $(this);
    var item_number = $this.data( 'tab-item' );
    var $all_items  = $this.closest('.js-tab-block')
      .find('.single-tab');
    var $this_item  = $this.closest('.js-tab-block')
      .find('.single-tab[data-tab-item=' + item_number +  ']');

    if ( $this.hasClass( 'is-active' )) {

    } else {
      $tab_button.removeClass( 'is-active' );
      $all_items.fadeOut( 400 )
        .removeClass( 'is-active' );

      $this.addClass( 'is-active' );
      $this_item.delay( 400 )
        .fadeIn( 400 )
        .addClass( 'is-active' );
    }

    return false;
  });

})(jQuery);
